import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import BuildFilter from '../../sitewide/Filter/BuildFilter'
import EmailTextFilter from './EmailTextFilter'
import MessagesFilterClearBar from '../../sitewide/Filter/MessagesFilterClearBar'
import SearchBar from '../../sitewide/Filter/SearchBar'
import AllLocationsCheckbox from '../../sitewide/Filter/AllLocationsCheckbox'
import css from './styles.css'

require('react-datepicker/dist/react-datepicker.css')

const MessagesFilter = ({
  activeDateFilterString,
  fetchNewConversationList,
  handleAllLocationsCheckbox,
  handleClearFilter,
  handleSearchChange,
  handleDateTimeChange,
  handleDateTimeSearch,
  handleRadioBtnSelect,
  hasDSO,
  locations,
  userLocations,
  radioDisabled,
  searchValue,
  selectConversationLocation,
  selectedLocationId,
  selectedRadioBtn,
  searchAllLocations,
  startDate,
  endDate,
  dateChanged,
}) => {
  const selectedEmailOrText = selectedRadioBtn !== 'all'
  const showAllLocationsCheckbox = hasDSO && userLocations && userLocations.length > 1
  const start = startDate ? startDate.local() : null
  const end = endDate ? endDate.local() : null

  return (
    <div className={css.wrapper}>
      <div className={css.filters}>
        {!hasDSO && (
          <div className={css.locationButtons}>
            <BuildFilter
              arrToFilter={locations}
              defaultOption="All Locations"
              filterLabel="name"
              onChange={selectConversationLocation}
              value={selectedLocationId}
            />
          </div>
        )}
        {showAllLocationsCheckbox && (
          <div className={css.allLocationCheckbox}>
            <AllLocationsCheckbox
              checked={searchAllLocations}
              handleCheck={handleAllLocationsCheckbox}
            />
          </div>
        )}
        <div className={css.dateTimeContainer}>
          <div className={css.dateTime}>
            <div className={css.fromDateTimePicker}>
              <div className={css.label}>From:</div>
              <DatePicker
                selected={start}
                onChange={date => handleDateTimeChange(date, 'startDate')}
                dateFormat="MM/DD/YY h:mm a"
                showTimeSelect
                placeholderText="Select a start date"
              />
            </div>
            <div className={css.toDateTimePicker}>
              <div className={css.label}>To:</div>
              <DatePicker
                selected={end}
                onChange={date => handleDateTimeChange(date, 'endDate')}
                dateFormat="MM/DD/YY h:mm a"
                showTimeSelect
                placeholderText="Select an end date"
              />
            </div>
          </div>
          <div className={css.btnContainer}>
            <button
              disabled={!dateChanged}
              onClick={handleDateTimeSearch}
              className={css.search}
            >
              Search by Time and Date
            </button>
          </div>
        </div>
        <div className={css.searchAndEmailText}>
          <SearchBar
            handleSearchParams={fetchNewConversationList}
            value={searchValue}
            onChange={handleSearchChange}
            placeholder="Search by name, phone, or email"
            isMessagesTab
          />
          <EmailTextFilter
            radioDisabled={radioDisabled}
            handleRadioBtnSelect={handleRadioBtnSelect}
            selectedRadioBtn={selectedRadioBtn}
          />
        </div>
      </div>
      <MessagesFilterClearBar
        activeDateFilterString={activeDateFilterString}
        handleClearFilter={handleClearFilter}
        hasDSO={hasDSO}
        searchValue={searchValue}
        selectedEmailOrText={selectedEmailOrText}
        selectedLocationId={selectedLocationId}
        selectedRadioBtn={selectedRadioBtn}
        selectedSearchTerm={searchValue}
      />
    </div>
  )
}

MessagesFilter.propTypes = {
  activeDateFilterString: PropTypes.string.isRequired,
  fetchNewConversationList: PropTypes.func.isRequired,
  hasDSO: PropTypes.bool.isRequired,
  handleAllLocationsCheckbox: PropTypes.func.isRequired,
  handleClearFilter: PropTypes.func.isRequired,
  handleDateTimeChange: PropTypes.func.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  handleDateTimeSearch: PropTypes.func.isRequired,
  handleRadioBtnSelect: PropTypes.func.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object),
  userLocations: PropTypes.arrayOf(PropTypes.object),
  radioDisabled: PropTypes.bool.isRequired,
  searchValue: PropTypes.string.isRequired,
  selectConversationLocation: PropTypes.func.isRequired,
  selectedLocationId: PropTypes.string.isRequired,
  selectedRadioBtn: PropTypes.string.isRequired,
  searchAllLocations: PropTypes.bool.isRequired,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  dateChanged: PropTypes.bool.isRequired,
}

export default MessagesFilter



// WEBPACK FOOTER //
// ./src/components/Messages/MessagesFilter/index.js